import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Box, ButtonBase, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { cardHoverLift, cardSurface, focusOutline } from './page-primitives';
const Root = styled(ButtonBase)(({ theme }) => ({
    ...cardSurface(theme),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    textAlign: 'left',
    overflow: 'hidden',
    flexGrow: 1,
    maxWidth: '16rem',
    gap: '0.625rem',
    padding: '0.625rem 0.875rem 0.625rem 0.75rem',
    color: theme.palette.text.primary,
    transition: 'border-color 0.15s, box-shadow 0.15s, transform 0.15s',
    ...cardHoverLift(theme),
    ...focusOutline(theme),
    '& .MuiTouchRipple-root': { color: theme.palette.secondary.main }
}));
export const CategoryCard = ({ label, icon: Icon, onClick }) => (_jsxs(Root, { onClick: onClick, children: [_jsx(Box, { sx: {
                width: '1.875rem',
                height: '1.875rem',
                // sx multiplies by theme.shape.borderRadius
                borderRadius: 1,
                bgcolor: 'accentSoft',
                color: 'secondary.main',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0
            }, children: _jsx(Icon, { sx: { fontSize: '1.0625rem' } }) }), _jsx(Typography, { noWrap: true, sx: { fontSize: '0.875rem', fontWeight: 600, minWidth: 0 }, children: label })] }));
//# sourceMappingURL=category-card.js.map